module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAALFJREFUeNpiYBgFwx0wk6tRSlxanpeHj+Hz188/ydHPRIGjLwBxAbmaKbFYgJKgZqEwqhSAQW6PHArPXj79SGsfg0ACEB9AwgX08vECKEaOd7pY/AAYtAfpnbgoAqMWj1o8avGoxfSzGFgb6RMjRgsfTwBaFI9k6XwgFUCvoIbVSAXQqpEucQyy7ANSKwRUFU4g1RBGMht6+tCK/wEQOxDb6qAKAFkOxPyjDfVBDwACDADW8CMAiZ64/wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/vent/1.png
// module id = 756
// module chunks = 0